import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

function parallax() {
	const all = document.querySelectorAll('[data-parallax]');
	const parallaxElements = Array.from(all).filter(el => el.getAttribute('data-parallax') === '' || el.getAttribute('data-parallax') === null); // Regular parallax.
	const parallaxOnScrollElements = Array.from(all).filter(el => el.getAttribute('data-parallax') === 'on-scroll');						     // Initialize on scroll.

	// Regular parallax
	if ( parallaxElements.length > 0 ) {
		parallaxElements.forEach(element => {
			const elementSpeed = element.getAttribute('data-parallax-speed') || 1;
			let space = 50

			if ( window.innerWidth < 992 ) {
				// Mobile
				if ( element.getAttribute('data-parallax-mobile') === 'none' ) {
					//console.log('Mobile parallax is none');
					return;
				} else if ( element.getAttribute('data-parallax-mobile') === 'horizontal' ) {
					//console.log('Mobile parallax is horizontal');
					gsap.to(element, {
						x: `${space * elementSpeed}%`,
						scrollTrigger: {
							trigger: element,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true
						}
					});
				} else {
					//console.log('Mobile parallax is vertical');
					gsap.to(element, {
						y: `${-space * elementSpeed}%`,
						scrollTrigger: {
							trigger: element,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true
						}
					});
				}
			} else {
				// Desktop
				if ( element.getAttribute('data-parallax') === 'horizontal' ) {
					//console.log('Desktop parallax is horizontal');
					gsap.to(element, {
						x: `${space * elementSpeed}%`,
						scrollTrigger: {
							trigger: element,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true
						}
					});
				} else {
					//console.log('Desktop parallax is vertical');
					gsap.to(element, {
						y: `${-space * elementSpeed}%`,
						scrollTrigger: {
							trigger: element,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true
						}
					});
				}
			}
		});
	}

	// Initialize on first scroll only
	if (parallaxOnScrollElements.length > 0) {
		const initOnScroll = () => {
			parallaxOnScrollElements.forEach(element => {
				const elementPosition = element.getBoundingClientRect().top;
				const elementSpeed = element.getAttribute('data-parallax-speed') || 1;

				if ( window.innerWidth < 992 ) {
					if ( element.getAttribute('data-parallax-mobile') === 'none' ) {
						// console.log('Mobile parallax is none');
						return;
					} else {
						// console.log('Mobile parallax is vertical');
						gsap.to(element, {
							y: `${-50 * elementSpeed}%`,
							scrollTrigger: {
								trigger: element,
								start: `top ${elementPosition}px`,
								end: 'bottom top',
								scrub: true,
								//markers: true
							}
						});
					}
				} else {
					// console.log('Desktop parallax is vertical');
					gsap.to(element, {
						y: `${-50 * elementSpeed}%`,
						scrollTrigger: {
							trigger: element,
							start: `top ${elementPosition}px`,
							end: 'bottom top',
							scrub: true,
							//markers: true
						}
					});
				}

				
			});
			window.removeEventListener('scroll', initOnScroll);
		};
		window.addEventListener('scroll', initOnScroll, { passive: true });
	}
}


export default parallax;